(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6JRY6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e80cf122b9d3f49$export$2e2bcd8739ae039; });

var $2Xzd1 = parcelRequire("2Xzd1");
var $4e80cf122b9d3f49$var$faq = {
    /**
     * Initializes every FAQ block inside root, or root itself when it is one.
     * Safe to call repeatedly: ACF replaces the preview DOM after every field change.
     */ init: function init(root) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _blocks;
        var scope = root || document;
        var blocks = [];
        if (scope.matches && scope.matches('.faq')) blocks.push(scope);
        if (scope.querySelectorAll) (_blocks = blocks).push.apply(_blocks, (0, $2Xzd1._)(scope.querySelectorAll('.faq')));
        blocks.forEach(function(block) {
            _this.bindBlock(block, options);
        });
    },
    bindBlock: function bindBlock(block) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var items = block.querySelectorAll('.faq__item');
        if (!items.length) return;
        items.forEach(function(item) {
            _this.bindItem(item, options);
        });
    },
    bindItem: function bindItem(item) {
        var _this = this;
        var question = item.querySelector('.faq__question');
        var answer = item.querySelector('.faq__answer');
        if (!question || !answer || item.dataset.faqReady === 'true') return;
        item.dataset.faqReady = 'true';
        question.addEventListener('click', function() {
            var isExpanded = question.getAttribute('aria-expanded') === 'true';
            _this.toggle(item, question, answer, !isExpanded);
        });
    },
    toggle: function toggle(item, question, answer, open) {
        if (open) {
            item.classList.add('is-active');
            question.setAttribute('aria-expanded', 'true');
            answer.setAttribute('aria-hidden', 'false');
            answer.style.maxHeight = answer.scrollHeight + 'px';
        } else {
            item.classList.remove('is-active');
            question.setAttribute('aria-expanded', 'false');
            answer.setAttribute('aria-hidden', 'true');
            answer.style.maxHeight = '0';
        }
    }
};
var $4e80cf122b9d3f49$export$2e2bcd8739ae039 = $4e80cf122b9d3f49$var$faq;
// The editor boots this module through src/js/_editor.js instead.
if (!window.acf) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() {
        return $4e80cf122b9d3f49$var$faq.init(document, {
            isEditor: false
        });
    });
    else $4e80cf122b9d3f49$var$faq.init(document, {
        isEditor: false
    });
}

});
parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});




parcelRequire("6JRY6");
})();
//# sourceMappingURL=script.js.map
